import { ModuleContainer } from '@components/undock/modules'
import styled from '@emotion/styled'
import { colorGrayscaleDark1 } from '@lib/colors'
import { mediaQueries } from '@lib/mediaQueries'

export const Container = styled(ModuleContainer)(
  mediaQueries({
    display: 'flex',
    flexWrap: ['wrap', 'wrap', 'wrap', 'nowrap', 'nowrap'],
    justifyContent: 'space-between',
  })
)

export const ContentWrapper = styled.div({
  marginBottom: '3rem',
})

export const FormWrapper = styled.div(
  mediaQueries({
    width: ['100%', '100%', 'calc(50% - 2rem)'],
  })
)

export const InfoHeader = styled.div({
  alignItems: 'center',
  color: colorGrayscaleDark1,
  display: 'flex',
  fontSize: '.75rem',
  textTransform: 'uppercase',
  img: {
    marginRight: '.5rem',
  },
})

export const InfoWrapper = styled.div(
  mediaQueries({
    width: ['100%', '100%', 'calc(50% - 2rem)'],
  })
)
